import { createEntityAdapter } from "@reduxjs/toolkit";
import { File } from "./dataTypes";

export const fileAdapter = createEntityAdapter<File>({});
